import React, { useState, useEffect } from 'react';
import { AuthContext } from './authContext';
import { accessTokenName } from '@/interceptors/common';
// import jwtDecode from "jwt-decode";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthLoading, setIsAuthLoading] = useState<boolean>(true);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false); // true - для коректної робити приватних роутів при натисканні F5

  useEffect(() => {
    setIsAuthLoading(true);
    const tokenToUse: string | null = localStorage.getItem('catalogueProfileAccessToken');
    setIsAuthenticated(!!tokenToUse);
    setIsAuthLoading(false);
  }, []);

  /** Decode JWT token and save user data to current provider */
  const signin = async (token: string): Promise<void> => {
    localStorage.setItem(accessTokenName, token);
    setIsAuthenticated(true);
  };

  /**  */
  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem(accessTokenName);
  };

  if (isAuthLoading) {
    return null;
  }

  const value = { isAuthLoading, isAuthenticated, signin, logout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
